module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "contactsection"
    }
  }, [_c('div', {
    staticClass: "columns is-multiline is-centered is-gapless"
  }, [_c('div', {
    staticClass: "column is-5 has-text-centered"
  }, [_c('div', {
    staticClass: "cont-desc",
    staticStyle: {
      "margin-bottom": "40px"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('ul', {
    staticClass: "info-list"
  }, [_c('li', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "context"
  }, [_vm._v("phone")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n              (6) 03 7806 1491\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "context"
  }, [_vm._v("email")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "mailto:sales@lasting-impressions.com.my;jonathan@lasting-impressions.com.my",
      "target": "_blank"
    }
  }, [_vm._v("\n                sales@lasting-impressions.com.my\n              ")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61d3fda0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactSection.vue
// module id = 744
// module chunks = 1